import { useState } from "react";
import commonHeaderStyles from "~/components/Document/commonDocumentHeader/index.module.scss";
import SelectionModal from "~/components/Summary/importSelectionModal";
import SummaryListView from "~/components/Summary/summaryListView";
import Button from "~/components/ui/button";

const Summary = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  return (
    <div>
      <div className={commonHeaderStyles["commonDocumentHeader"]}>
        <div className={commonHeaderStyles["commonDocumentHeader-inner"]}>
          <div className={commonHeaderStyles["commonDocumentHeader-left"]}>
            <h1>議事録</h1>
          </div>
          <div className={commonHeaderStyles["commonDocumentHeader-right"]}>
            <div className={commonHeaderStyles["commonDocumentHeader-buttons"]}>
              <Button
                styleType="file-upload"
                label={"アップロード"}
                onClick={handleOpenModal}
                icon={"fileUploadIcon"}
              />
            </div>
          </div>
        </div>
      </div>
      <SummaryListView />
      {/* モーダル表示 */}
      {isModalOpen && <SelectionModal onClose={handleCloseModal} />}
    </div>
  );
};

export default Summary;
